<div class="container-fluid" style="background-color: #1d2229">
    <div class="row">
        <div class="col-sm-2">
            <div class="content">
                <div class="container-lg text-center" style="background-color: #1d2229">
                    <div class="row">
                        <div class="d-grid gap-2 col-sm-12 mx-auto">
                            <button type="button" class="btn btn-outline-primary" [routerLink]="['./dock', 31]"
                                [ngStyle]="{ color: statusDocks(31) }">
                                Doca 1
                            </button>
                        </div>
                        <div class="d-grid gap-2 col-sm-12 mx-auto">
                            <button type="button" class="btn btn-outline-primary" [routerLink]="['./dock', 32]"
                                [ngStyle]="{ color: statusDocks(32) }">
                                Doca 2
                            </button>
                        </div>
                        <div class="d-grid gap-2 col-sm-12 mx-auto">
                            <button type="button" class="btn btn-outline-primary" [routerLink]="['./dock', 33]"
                                [ngStyle]="{ color: statusDocks(33) }">
                                Doca 3
                            </button>
                        </div>
                        <div class="d-grid gap-2 col-sm-12 mx-auto">
                            <button type="button" class="btn btn-outline-primary" [routerLink]="['./dock', 34]"
                                [ngStyle]="{ color: statusDocks(34) }">
                                Doca 4
                            </button>
                        </div>
                        <div class="d-grid gap-2 col-sm-12 mx-auto">
                            <button type="button" class="btn btn-outline-primary" [routerLink]="['./dock', 35]"
                                [ngStyle]="{ color: statusDocks(35) }">
                                Doca 5
                            </button>
                        </div>
                        <div class="d-grid gap-2 col-sm-12 mx-auto">
                            <button type="button" class="btn btn-outline-primary" (click)="openPlanning()">
                                Time Table
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="col-sm-10">
            <router-outlet></router-outlet>
        </div>

    </div>
</div>

<app-chassis-time-table *ngIf="timeTableIsVisible"></app-chassis-time-table>
